<template lang="pug">
.question-answer-details-modal
  b-modal(v-model="_value" size="xl" @ok="ok" :title="title" no-close-on-backdrop no-close-on-esc)
    .question-answer-details-modal-body
      OtherUserSafetyConfirmAnswerDetailsTable(
        v-model="_items"
        :fields="fields"
      )

    template(#modal-footer="{ ok }")
      .d-flex.justify-content-end
        .table-options.d-flex.flex-row.justify-content-end.align-items-top.mr-2(v-if="confirm")
          // フィルタリング
          MultiSelect(
            v-model="confirm.filter.groupIds" :options="confirm.filter.filterOptions"
            key-name="施設関係者グループ" name="groupIds" :width="240"
            :id="'other-user-safety-confirm-answer-details-modal-filter-input'" :name="'other-user-safety-confirm-answer-details-modal-filter-input'"
            style="width: 240px; flex-grow: 0;")
        b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import OtherUserSafetyConfirmAnswerDetailsTable, {
  OtherUserSafetyConfirmAnswerDetailsModalTableField,
  OtherUserSafetyConfirmAnswerDetailsModalTableItem
} from "@/pc/containers/safetyConfirms/OtherUserSafetyConfirmAnswerDetailsTable.vue";
import MultiSelect from "@/pc/containers/safetyConfirms/MultiSelect.vue";
import { Confirm, ConfirmFilter } from "@/pc/pages/safetyConfirm/OtherUserSafetyConfirmDetail.vue";

/**
 * ### 施設関係者の安否確認の回答結果詳細モーダル
 */
@Component({
  components: {
    OtherUserSafetyConfirmAnswerDetailsTable,
    MultiSelect
  }
})
export default class OtherUserSafetyConfirmAnswerDetailsModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  title!: string;
  /** テーブル行情報 */
  @Prop({ required: true })
  items!: Array<OtherUserSafetyConfirmAnswerDetailsModalTableItem>;
  /** 安否確認 */
  @Prop()
  confirm!: Confirm;

  /** テーブル列情報 */
  fields: Array<OtherUserSafetyConfirmAnswerDetailsModalTableField> = [];

  /**
   * ### vue lifecycle mounted
   */
  mounted(): void {
    const fields = this.createFields();
    this.fields = fields;
    return;
  }

  /**
   * ### 列情報作成
   */
  private createFields(): Array<OtherUserSafetyConfirmAnswerDetailsModalTableField> {
    const fields: Array<OtherUserSafetyConfirmAnswerDetailsModalTableField> = [];

    fields.push({ key: "groupTypeName", label: "種類", sortable: false, sortDirection: "desc", class: "group-type-name" });
    fields.push({ key: "groupName", label: "グループ名", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "memberName", label: "ユーザー名", sortable: false, sortDirection: "desc", class: "member-name" });
    fields.push({ key: "memberTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "member-tel" });
    fields.push({ key: "memberOrganization", label: "所属", sortable: false, sortDirection: "desc", class: "member-organization" });
    fields.push({ key: "answer", label: "回答", sortable: false, sortDirection: "desc", class: "answer" });
    fields.push({ key: "answerDatetime", label: "回答日時", sortable: false, sortDirection: "desc", class: "answer-datetime" });

    return fields;
  }

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _items(): Array<OtherUserSafetyConfirmAnswerDetailsModalTableItem> {
    if (!this.confirm) {
      return [];
    }
    const filter: ConfirmFilter = this.confirm.filter as ConfirmFilter;
    const groupIds: string[] = filter.groupIds as string[];
    const idMap: Map<number, string> = new Map();
    for (const groupId of groupIds) {
      idMap.set(Number(groupId), groupId);
    }

    const filterdItems: Array<any> = this.items.concat().filter((item) => {
      return idMap.has(item.groupId);
    });

    return filterdItems.filter((item) => {
      return item.answer ? true : false;
    });
  }

  set _items(newValue: Array<OtherUserSafetyConfirmAnswerDetailsModalTableItem>) {
    this.$emit("update:items", newValue);
    return;
  }

  get _fields(): Array<OtherUserSafetyConfirmAnswerDetailsModalTableField> {
    return this.fields;
  }

  set _fields(newValue: Array<OtherUserSafetyConfirmAnswerDetailsModalTableField>) {
    this.$emit("update:fields", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
